import React, { Component } from 'react';
import { unescapeHTML, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import CustomerSearch from '../../site/customer-search';
import CargomaticCard from '../../v2/card';

import CustomersActionCreators from '../../../actions/CustomersActionCreators';

class AssociateAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      associationId: null,
    };
  }

  saveAssociation() {
    CustomersActionCreators.associateShipper({
      shipperId: this.props.userId,
      masterId: this.state.associationId,
    });
  }

  handleReset = () => {
    CustomersActionCreators.associateShipper({
      shipperId: this.props.userId,
      masterId: this.props.userId,
    });
  };

  render() {
    const { t } = this.props;
    const hasAssociation =
      this.props.currentAssociation &&
      this.props.userId !== this.props.currentAssociation.id;

    let masterAccountLink;

    if (hasAssociation) {
      masterAccountLink = `/users/${this.props.currentAssociation.id}`;
    }
    return (
      <CargomaticCard
        header={() => (
          <h3 className="my-0 text-xl font-medium">{t('MASTER_ACCOUNT')}</h3>
        )}
        footer={() => (
          <div className="flex items-center justify-end -mx-2 text-right">
            <div className="px-2">
              <button
                className="my-2 button button-green"
                onClick={() => this.saveAssociation()}
              >
                {t('ASSOCIATE')}
              </button>
            </div>
            {hasAssociation && (
              <div className="px-2">
                <button
                  className="button button-secondary"
                  onClick={this.handleReset}
                >
                  {titleize(t('RESET'))}
                </button>
              </div>
            )}
          </div>
        )}
        grayFooter
      >
        {hasAssociation && (
          <div className="flex items-center mb-2">
            <label className="my-0 mr-2 form-label">
              {t('MASTER_ACCOUNT')}:
            </label>
            <strong className="my-0">
              <a
                href={masterAccountLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {unescapeHTML(this.props.currentAssociation.name)}
              </a>
            </strong>
          </div>
        )}

        {!hasAssociation && (
          <label className="mb-2 form-lbel">{t('LINK_ACCOUNT')}</label>
        )}
        <div className="mb-4">
          <CustomerSearch
            type="master_shippers"
            onSelect={(_name, details) => {
              this.setState({ associationId: details.value });
            }}
          />
        </div>
      </CargomaticCard>
    );
  }
}

AssociateAccount.defaultProps = { currentAssociation: {} };

export default withTranslation()(AssociateAccount);
